/*eslint no-unreachable: "off"*/
/*eslint no-useless-concat: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-useless-escape: "off"*/

import {numberWithCommas} from "../../../utils";
import imgPersonType1 from "../../../images/person_type_1.png";
import imgPersonType2 from "../../../images/person_type_2.png";
import imgPersonType3 from "../../../images/person_type_3.png";
import imgPersonType1_25 from "../../../images/person_type_1_25.png";
import imgPersonType2_25 from "../../../images/person_type_2_25.png";
import imgPersonType3_25 from "../../../images/person_type_3_25.png";


export function getChart1Data({ adminYn, item }, { gubun_code, prm_check, prm_check2 }) {
  const chart1RawData = item;

  const chart1Data = [];
  const chart1Data2 = [];

  let table1Html = '<caption>무선국 밀도(무선국수/인구 천 명)</caption><colgroup><col width="50px"><col width="150px"><col width="*"></colgroup>';
  let table1Html2 = '<caption>무선국 밀도(무선국수/인구 천 명)</caption><colgroup><col width="50px"><col width="150px"><col width="*"></colgroup>';

  for (let i = 0; i < chart1RawData.length; ++i) {
    const item = chart1RawData[i];
    let personImg = "";

    switch (item.DATA_TYPE) {
      case 'DATA_TYPE1' : // 인구유형별 인구수

        if (item.DATA_COLUMN === 'CHILD') personImg = `<img src="${imgPersonType2}" alt=\"어린이\" width='18'/>`;
        else if (item.DATA_COLUMN === 'MIDDLE') personImg = `<img src="${imgPersonType1}" alt="경제인구" width='20'/>`;
        else if (item.DATA_COLUMN === 'OLD') personImg = `<img src="${imgPersonType3}" alt="노년인구" width='20'/>`;
        else personImg = "";

        table1Html += "<tr>";
        table1Html += "<td scope=\"row\" class=\"pdl15\" style=\"background:#f8f8f8;font-size:14px;\">" + personImg + "</td>";
        table1Html += "<td scope=\"row\" class=\"pdl15 text_c\" style=\"background:#f8f8f8;font-size:14px;text-align:center !important;\">" + item.DATA_FIELD + "</td>";
        table1Html += "<td class=\"text_r\" style=\"font-size:14px;padding-right:20px;\">" + numberWithCommas(item.DATA_SUM) + "</td>";
        table1Html += "</tr>";
        break;

      case 'DATA_TYPE2' : // 인구유형별 서비스별 밀도
        let tmpData = {};
        tmpData.DATA_FIELD = item.DATA_FIELD;
        tmpData.DATA_COLUMN = item.DATA_COLUMN;
        tmpData.DATA_SUM = Number(item.DATA_SUM).toFixed(2);
        tmpData.DATA_SUM_str = numberWithCommas(Number(item.DATA_SUM).toFixed(2));

        if (item.DATA_COLUMN === 'CHILD') personImg = `<img src="${imgPersonType2}" alt=\"어린이\" width='18' style="padding-right: 10px;" />`;
        else if (item.DATA_COLUMN === 'MIDDLE') personImg = `<img src="${imgPersonType1}" alt="경제인구" width='20' style="padding-right: 10px;" />`;
        else if (item.DATA_COLUMN === 'OLD') personImg = `<img src="${imgPersonType3}" alt="노년인구" width='20' style="padding-right: 10px;" />`;
        else personImg = "";

        if (i === 4) table1Html2 += "<tr>";
        //table1Html2 += "<td scope=\"row\" class=\"pdl15\" style=\"background:#f8f8f8;font-size:14px;\">"+personImg+"</td>";
        table1Html2 += "<td scope=\"row\" class=\"text_c\" style=\"background:#f8f8f8;font-size:14px;width:25%;\">" + personImg + item.DATA_FIELD + "</td>";
        //table1Html2 += "<td class=\"pdr15 text_r\" style=\"font-size:14px;\" name=\"we\">"+numberWithCommas((item.DATA_SUM2).toFixed(2))+"</td>";
        if (i === chart1RawData.length) table1Html2 += "</tr>";

        if (item.DATA_COLUMN !== 'AGE_TOTAL') {
          const tmpSourceItem = {};
          tmpSourceItem.DATA_FIELD = item.DATA_FIELD;
          tmpSourceItem['DATA_' + item.DATA_COLUMN] = (item.DATA_SUM).toFixed(2);

          chart1Data.push(tmpSourceItem);
        }

        if ( gubun_code === "service" ) {
          for ( let j = 0; j < prm_check.length; j++ ) {
            if ( adminYn === 'Y' ) {
              tmpData['DATA_' + prm_check[j] + '_LG'] =
                Number(item['DATA_' + prm_check[j] + '_LG']).toFixed(2);
              tmpData['DATA_' + prm_check[j] + '_LG_str'] =
                numberWithCommas(Number(item['DATA_' + prm_check[j] + '_LG']).toFixed(2));
              tmpData['DATA_' + prm_check[j] + '_KT'] =
                Number(item['DATA_' + prm_check[j] + '_KT']).toFixed(2);
              tmpData['DATA_' + prm_check[j] + '_KT_str'] =
                numberWithCommas(Number(item['DATA_' + prm_check[j] + '_KT']).toFixed(2));
              tmpData['DATA_' + prm_check[j] + '_SK'] =
                Number(item['DATA_' + prm_check[j] + '_SK']).toFixed(2);
              tmpData['DATA_' + prm_check[j] + '_SK_str'] =
                numberWithCommas(Number(item['DATA_' + prm_check[j] + '_SK']).toFixed(2));
            } else {
              tmpData['DATA_' + prm_check[j]] =
                Number(item['DATA_' + prm_check[j]]).toFixed(2);
              tmpData['DATA_' + prm_check[j] + '_str'] =
                numberWithCommas(Number(item['DATA_' + prm_check[j]]).toFixed(2));
            }
          }
        } else {
          for ( let j = 0; j < prm_check2.length; j++ ) {
            tmpData['DATA_' + prm_check2[j]] =
              Number(item['DATA_' + prm_check2[j]]).toFixed(2);
            tmpData['DATA_' + prm_check2[j] + '_str'] =
              numberWithCommas(Number(item['DATA_' + prm_check2[j]]).toFixed(2));
          }
        }
        chart1Data2.push(tmpData);
        break;
      // no default
    }
  }
  for (let i = 0; i < chart1RawData.length; ++i) {
    const item = chart1RawData[i];

    switch (item.DATA_TYPE) {
      case 'DATA_TYPE2' : // 인구유형별 서비스별 밀도
        if (i === 4) table1Html2 += "<tr>";
        table1Html2 += "<td class=\"text_c\" style=\"font-size:14px;\" name=\"we\">" +
          numberWithCommas((item.DATA_SUM2 || item.DATA_SUM).toFixed(2)) + "</td>";
        if (i === chart1RawData.length) table1Html2 += "</tr>";
        break;
      // no default
    }
  }

  return {
    chart1Data,
    chart1Data2,
    table1Html,
    table1Html2,
  };
}


// 정보 밀도 기준 정렬
export function getChart2Data({ item2 }) {
  const sorted = item2.slice().sort(function (a, b) {
    return b.DATA_SUM_SUM_CNT - a.DATA_SUM_SUM_CNT;
  });

  return {
    chart2Data: sorted,
    chart2Data2: sorted,
  };
}


export function getChart3Data({ item3 }) {
  return {
    chart3Data: item3.slice(),
  };
}


export function getLayoutForChartTypeImage(chartLayoutProps, {searchYear}) {
  let dataTipJsFunctionData;
  if ( chartLayoutProps.valueFixed > 0 ) {
    dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2_image"';
  } else {
    dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0_image"';
  }

  const layOutData =
    '<rMateChart backgroundColor="#FFFFFF">'
    + '<Options>'
    + '<Caption text="' + chartLayoutProps.title + ' " fontSize="17"/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear + '년)"/>'
    + '</Options>'
    + '<NumberFormatter id="numFmt"/>'
    + '<Column2DChart id="chart"' + dataTipJsFunctionData + ' showDataTips="true" type="overlaid" showLabelVertically="true">'
    + '<horizontalAxis>'
    + '<CategoryAxis id="hAxis" categoryField="DATA_FIELD" padding="0.7" labelJsFunction="labelFunc"/>'
    + '</horizontalAxis>'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis"/>'
    + '</verticalAxis>'
    + '<series>'
    + '<ImageSeries labelPosition="outside" yField="DATA_CHILD" maxColumnWidth="10"  imageDisplayType="single" styleName="seriesStyle" displayName="어린이" formatter="{numFmt}" fill="' + chartColor('어린이') + '" halfWidthOffset="5" showValueLabels="[2,3]">'
    + '<imgSource>'
    + `<ImageSourceItem maintainAspectRatio="true" url="${imgPersonType2_25} "/>`
    + '</imgSource>'
    + '<showDataEffect>'
    + '<SeriesSlide duration="1000" direction="up"/>'
    + '</showDataEffect>'
    + '</ImageSeries>'
    + '<ImageSeries labelPosition="outside" yField="DATA_MIDDLE" maxColumnWidth="10" imageDisplayType="single" styleName="seriesStyle2" displayName="경제인구" formatter="{numFmt}" fill="' + chartColor('경제인구') + '" halfWidthOffset="5" showValueLabels="[2,3]">'
    + '<imgSource>'
    + `<ImageSourceItem maintainAspectRatio="true" url="${imgPersonType1_25}"/>`
    + '</imgSource>'
    + '<showDataEffect>'
    + '<SeriesSlide duration="1000" direction="up"/>'
    + '</showDataEffect>'
    + '</ImageSeries>'
    + '<ImageSeries labelPosition="outside" yField="DATA_OLD" maxColumnWidth="10" imageDisplayType="single" styleName="seriesStyle2" displayName="노년" formatter="{numFmt}" fill="' + chartColor('노년') + '" halfWidthOffset="5" showValueLabels="[2,3]">'
    + '<imgSource>'
    + `<ImageSourceItem maintainAspectRatio="true" url="${imgPersonType3_25}" />`
    + '</imgSource>'
    + '<showDataEffect>'
    + '<SeriesSlide duration="1000" direction="up"/>'
    + '</showDataEffect>'
    + '</ImageSeries>'
    + '</series>'
    + '<verticalAxisRenderers>'
    + '<Axis2DRenderer axis="{vAxis}" visible="false"/>'
    + '</verticalAxisRenderers>'
    + '</Column2DChart>'
    + '<Style>'
    + '.seriesStyle{labelPosition:outside;}'
    + '.seriesStyle2{labelPosition:outside;}'
    + '</Style>'
    + '</rMateChart>';

  return layOutData;
}


export function getLayoutForChartTypeMultiSeriesStacked(chartLayoutProps, { gubun_code, searchYear}) {
  let dataTipJsFunctionData;
  if ( chartLayoutProps.valueFixed > 0 ) {
    if ( chartLayoutProps.layOutStyle === 'Mater' ) {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2_stacked"';
    }
  } else {
    if ( chartLayoutProps.layOutStyle === 'Mater' ) {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0_stacked"';
    }
  }

  let layOutData =
    '<rMateChart backgroundColor="#FFFFFF" borderStyle="none" >'
    + '<Options>'
      + '<Caption fontSize="19" text="' + chartLayoutProps.title + '  "/>'
      + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear + '년)"/>'
      + '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15"/>'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Column3DChart showDataTips="true"' + dataTipJsFunctionData + '>'
    + '<horizontalAxis>'
    + '<CategoryAxis id="hAxis" title="' + chartLayoutProps.xtitle + '" categoryField="GUBUN_NM" labelJsFunction="labelFunc"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" labelRotation="45" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis formatter="{numfmt}" id="vAxis" title="' + chartLayoutProps.ytitle + '" labelJsFunction="labelFuncNum" />'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<series>';

  if ( chartLayoutProps.layOutStyle === 'Mater' ) {
    layOutData +=
      '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
      + '<series>'
      + '<Column3DSeries labelPosition="inside" yField="DATA_SUM" displayName="' + chartLayoutProps.masterName + '" styleName="seriesLabel" showValueLabels="[]">'
      + '<showDataEffect>'
      + '<SeriesInterpolate/>'
      + '</showDataEffect>'
      + '</Column3DSeries>'
      + '</series>'
      + '</Column3DSet>';
  } else {
    if ( gubun_code === "service" ) {
      layOutData +=
        '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
        + '<series>';

      layOutData += '<Column3DSeries labelPosition="inside" yField="DATA_SUM_CHILD_CNT" displayName="어린이" styleName="seriesLabel" showValueLabels="[]">'
        + '<fill>'
        + '<SolidColor color="' + chartColor('어린이') + '"/>'
        + '</fill>'
        + '<showDataEffect>'
        + '<SeriesInterpolate/>'
        + '</showDataEffect>'
        + '</Column3DSeries>';

      layOutData += '</series>'
        + '</Column3DSet>';

      layOutData +=
        '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
        + '<series>';

      layOutData += '<Column3DSeries labelPosition="inside" yField="DATA_SUM_MIDDLE_CNT" displayName="경제인구" styleName="seriesLabel" showValueLabels="[]">'
        + '<fill>'
        + '<SolidColor color="' + chartColor('경제인구') + '"/>'
        + '</fill>'
        + '<showDataEffect>'
        + '<SeriesInterpolate/>'
        + '</showDataEffect>'
        + '</Column3DSeries>';

      layOutData += '</series>'
        + '</Column3DSet>';

      layOutData +=
        '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
        + '<series>';

      layOutData += '<Column3DSeries labelPosition="inside" yField="DATA_SUM_OLD_CNT" displayName="노년" styleName="seriesLabel" showValueLabels="[]">'
        + '<fill>'
        + '<SolidColor color="' + chartColor('노년') + '"/>'
        + '</fill>'
        + '<showDataEffect>'
        + '<SeriesInterpolate/>'
        + '</showDataEffect>'
        + '</Column3DSeries>';

      layOutData += '</series>'
        + '</Column3DSet>';
    } else {
      layOutData +=
        '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
        + '<series>';

      layOutData += '<Column3DSeries labelPosition="inside" yField="DATA_SUM_CHILD_CNT" displayName="어린이" styleName="seriesLabel" showValueLabels="[]">'
        + '<fill>'
        + '<SolidColor color="' + chartColor('어린이') + '"/>'
        + '</fill>'
        + '<showDataEffect>'
        + '<SeriesInterpolate/>'
        + '</showDataEffect>'
        + '</Column3DSeries>';

      layOutData += '</series>'
        + '</Column3DSet>';

      layOutData +=
        '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
        + '<series>';

      layOutData += '<Column3DSeries labelPosition="inside" yField="DATA_SUM_MIDDLE_CNT" displayName="경제인구" styleName="seriesLabel" showValueLabels="[]">'
        + '<fill>'
        + '<SolidColor color="' + chartColor('경제인구') + '"/>'
        + '</fill>'
        + '<showDataEffect>'
        + '<SeriesInterpolate/>'
        + '</showDataEffect>'
        + '</Column3DSeries>';


      layOutData += '</series>'
        + '</Column3DSet>';

      layOutData +=
        '<Column3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
        + '<series>';

      layOutData += '<Column3DSeries labelPosition="inside" yField="DATA_SUM_OLD_CNT" displayName="노년" styleName="seriesLabel" showValueLabels="[]">'
        + '<fill>'
        + '<SolidColor color="' + chartColor('노년') + '"/>'
        + '</fill>'
        + '<showDataEffect>'
        + '<SeriesInterpolate/>'
        + '</showDataEffect>'
        + '</Column3DSeries>';

      layOutData += '</series>'
        + '</Column3DSet>';
    }
  }
  layOutData +=
    '</series>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="horizontal"  enableZooming="true" enableCrossHair="false">'
    + '</CrossRangeZoomer>'
    /* CrossRangeZoomer 속성 설명
* zoomType : 줌 실행 기준을 정합니다. 유효값 : horizontal, vertical, both
* horizontalLabelFormatter : 십자가의 수평 라인에 붙는 라벨 formatter 입니다.
* verticalLabelFormatter : 십자가의 수직 라인에 붙는 라벨 formatter 입니다.
* enableZooming : zoom 기능 사용 여부를 나타냅니다.
* enableCrossHair : 십자가 표시 여부를 나타냅니다.
* useDualCrossXLabel : 십자가의 수평 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* useDualCrossYLabel : 십자가의 수직 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* verticalLabelPlacement : 수직 라인의 라벨 위치를 지정합니다.(유효값: top, bottom)
* horizontalLabelPlacement : 수평 라인의 라벨 위치를 지정합니다.(유효값 : left, right)
*/
    + '</annotationElements>'
    + '</Column3DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';

    return layOutData;
}


export function getLayoutForChartTypeCombination3DColumnLine(chartLayoutProps, {searchYear}) {
  let dataTipJsFunctionData;
  if ( chartLayoutProps.valueFixed > 0 ) {
    dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2_Bubble"';
  } else {
    dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0_Bubble"';
  }

  const layOutData =
    '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<Options>'
    + '<Caption text="' + chartLayoutProps.title + '  " fontSize="19"/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear + '년)"/>'
    + '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15" />'
    + '</Options>'
    + '<NumberFormatter id="numFmt" useThousandsSeparator="true" precision="0"/>'
    + '<Combination3DChart showDataTips="true">'
    /*
     Combination3D 차트 생성시에 필요한 Combination3DChart 정의합니다
  showDataTips : 데이터에 마우스를 가져갔을 때 나오는 Tip을 보이기/안보이기 속성입니다
    */
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis1" formatter="{numFmt}" title="' + chartLayoutProps.ytitle2 + '"  labelJsFunction="labelFuncNum"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis1}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis2}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<horizontalAxis>'
    + '<CategoryAxis id="hAxis" categoryField="YEAR" padding="0.5" title="' + chartLayoutProps.xtitle + '" />'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}"  axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<series>'
    + '<Column3DSeries columnWidthRatio="0.6" selectable="true" yField="RDW_CNT" displayName="무선국수">'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Column3DSeries>'
    + '<Line2DSeries itemRenderer="CircleItemRenderer" radius="6" labelPosition="up" selectable="true" yField="CHILD" displayName="어린이" styleName="lineSeriesLabel" showValueLabels="[]">'
    + '<fill>'
    + '<SolidColor color="' + chartColor('어린이') + '"/>'
    + '</fill>'
    + '<lineStroke>'
    + '<Stroke color="' + chartColor('어린이') + '" weight="3"/>'
    + '</lineStroke>'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis2" formatter="{numFmt}" title="' + chartLayoutProps.ytitle + '" labelJsFunction="labelFuncNum"  />'
    + '</verticalAxis>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Line2DSeries>'
    + '<Line2DSeries itemRenderer="CircleItemRenderer" verticalAxis="{vAxis2}" radius="6" labelPosition="up" selectable="true" yField="MIDDLE" displayName="경제인구" styleName="lineSeriesLabel" showValueLabels="[]">'
    + '<fill>'
    + '<SolidColor color="' + chartColor('경제인구') + '"/>'
    + '</fill>'
    + '<lineStroke>'
    + '<Stroke color="' + chartColor('경제인구') + '" weight="3"/>'
    + '</lineStroke>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Line2DSeries>'
    + '<Line2DSeries itemRenderer="CircleItemRenderer" verticalAxis="{vAxis2}" radius="6" labelPosition="up" selectable="true" yField="OLD" displayName="노년" styleName="lineSeriesLabel" showValueLabels="[]">'
    + '<fill>'
    + '<SolidColor color="' + chartColor('노년') + '"/>'
    + '</fill>'
    + '<lineStroke>'
    + '<Stroke color="' + chartColor('노년') + '" weight="3"/>'
    + '</lineStroke>'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Line2DSeries>'
    + '</series>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis1}" showLine="true" axisTitleStyleName="title"/>'
    + '<Axis3DRenderer axis="{vAxis2}" showLine="true" axisTitleStyleName="title"/>'
    + '</verticalAxisRenderers>'
    + '</Combination3DChart>'
    + '<Style>'
    + '.lineSeriesLabel{'
    + 'color:#777777;'
    + 'fontWeight:normal;'
    + '}'
    + '.title{color:0x4691E1; fontSize:15; fontWeight:bold;}'
    + '</Style>'
    + '</rMateChart>';

  return layOutData;
}


export function getLayoutForChartTypePie(chartLayoutProps) {
  let layOutData = '<rMateChart backgroundColor="#FFFFFF" borderStyle="none" >'
    + '<Options>'
    + '<Caption fontSize="19" text="' + chartLayoutProps.title + ' "/>'
    // '&lt;a href=javascript:cartDownload(\'chart' + i + '\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart' + i + '\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt; "/>'
    +'<SubCaption text="2013"/>'
    + '<Legend useVisibleCheck="true" fontSize="15"/>'
    + '</Options>'
    + '<Pie2DChart showDataTips="true" dataTipJsFunction="dataTipFunc2_Pie">'
    /* Pie2D 차트 생성시에 필요한 Pie2DChart 정의합니다. */
    /* showDataTips : 데이터에 마우스를 가져갔을 때 나오는 Tip을 보이기/안보이기 속성입니다. */
    + '<series>'
    + '<Pie2DSeries nameField="DATA_FIELD" field="DATA_SUM" labelPosition="none" color="#ffffff" startAngle="136">'
    /* Pie2DChart 정의 후 Pie2DSeries labelPosition="inside"정의합니다 */
    + '<showDataEffect>'
    /* 차트 생성시에 Effect를 주고 싶을 때 showDataEffect정의합니다 */
    + '<SeriesSlide duration="1000"/>'
    /* SeriesSlide 효과는 시리즈 데이터가 데이터로 표시될 때 한쪽에서 미끄러지듯 나타나는 효과를 적용합니다. */
    /* elementOffset : effect를 지연시키는 시간을 지정합니다 default:20 */
    /* minimumElementDuration : 각 엘리먼트의 최소 지속 시간을 설정합니다 default:0 */
    /* 이 값보다 짧은 시간에 effect가 실행되지 않습니다. */
    /* offset : effect개시의 지연시간을 설정합니다 default:0 */
    /* perElementOffset : 각 엘리먼트의 개시 지연시간을 설정합니다. */
    /* direction : left:왼쪽, right:오른쪽, up:위, down:아래 default는 left입니다. */
    + '</showDataEffect>'
    + '</Pie2DSeries>'
    + '</series>'
    + '</Pie2DChart>'
    + '</rMateChart>';

  return layOutData;
}


export function getLayoutForChartTypeLineItemRenderer(chartLayoutProps) {
  let layOutData =
    '<rMateChart  backgroundColor="#ffffff" borderStyle="none">'
    + '<Options>'
    + '<Caption fontSize="19" text="' + chartLayoutProps.title + ' " fontSize="19"/>'
    // &lt;a href=javascript:cartDownload(\'chart' + i + '\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart' + i + '\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt; "/>'
    + '<SubCaption text="" textAlign="center" />'
    + '<Legend useVisibleCheck="true" fontSize="15"/>'
    + '</Options>'
    + '<NumberFormatter id="numFmt" precision="0"/>'
    + '<Line2DChart showDataTips="true" paddingTop="0">'
    + '<horizontalAxis>'
    + '<CategoryAxis categoryField="LIST_YEAR" padding="0.2" labelJsFunction="labelFunc"/>'
    + '</horizontalAxis>'
    + '<verticalAxis>'
    + '<LinearAxis labelJsFunction="labelFuncNum"/>'
    + '</verticalAxis>'
    + '<series>'
    /*
      itemRenderer는 Tip이 보여지는 영역차트 부분에 ItemRenderer에서 제공하는 모양을 그려줍니다
      이 예제에서는 Diamond입니다
      사용할 수 있는 도형을 모두 표현한 예제는 Chart Samples 의 범례 예제를 참고하십시오.
     */
    + '<Line2DSeries yField="CHILD" fill="#ffffff" radius="5" displayName="어린이" itemRenderer="RectangleItemRenderer">'
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Line2DSeries>'
    + '<Line2DSeries labelPosition="up" yField="MIDDLE" fill="#ffffff" radius="5" displayName="경제인구" showValueLabels="[]" itemRenderer="CircleItemRenderer">'
    /* itemRenderer는 Circle입니다 */
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Line2DSeries>'
    + '<Line2DSeries yField="OLD" fill="#ffffff" radius="6" displayName="노년" itemRenderer="TriangleItemRenderer">'
    /* itemRenderer는 Triangle입니다 */
    + '<showDataEffect>'
    + '<SeriesInterpolate/>'
    + '</showDataEffect>'
    + '</Line2DSeries>'
    + '</series>'
    + '</Line2DChart>'
    + '</rMateChart>';

  return layOutData;
}


function chartColor(displayName) {
  if (displayName.indexOf('기지국') !== -1) return "#41b2e6";
  else if (displayName.indexOf('간이무선국') !== -1) return "#4452a8";
  else if (displayName.indexOf('육상이동국') !== -1) return "#fabc05";
  else if (displayName.indexOf('이동중계국') !== -1) return "#5587a2";
  else if (displayName.indexOf('이동국') !== -1) return "#69cabc";
  else if (displayName.indexOf('아마추어국') !== -1) return "#6c4a85";
  else if (displayName.indexOf('의무선박국') !== -1) return "#8a7860";
  else if (displayName.indexOf('선박국') !== -1) return "#96d4df";
  else if (displayName.indexOf('고정국') !== -1) return "#f7a33b";
  else if (displayName.indexOf('전파응용설비') !== -1) return "#d8c6aa";
  else if (displayName.indexOf('기타') !== -1) return "#999999";
  else if (displayName.indexOf('2G LG') !== -1) return "#41b2e6";
  else if (displayName.indexOf('3G LG') !== -1) return "#4452a8";
  else if (displayName.indexOf('LTE LG') !== -1) return "#fabc05";
  else if (displayName.indexOf('2G KT') !== -1) return "#5587a2";
  else if (displayName.indexOf('3G KT') !== -1) return "#69cabc";
  else if (displayName.indexOf('LTE KT') !== -1) return "#6c4a85";
  else if (displayName.indexOf('2G SK') !== -1) return "#8a7860";
  else if (displayName.indexOf('3G SK') !== -1) return "#96d4df";
  else if (displayName.indexOf('LTE SK') !== -1) return "#f7a33b";
  else if (displayName.indexOf('2G 어린이') !== -1) return "#41b2e6";
  else if (displayName.indexOf('3G 어린이') !== -1) return "#4452a8";
  else if (displayName.indexOf('LTE 어린이') !== -1) return "#fabc05";
  else if (displayName.indexOf('2G 경제인구') !== -1) return "#5587a2";
  else if (displayName.indexOf('3G 경제인구') !== -1) return "#69cabc";
  else if (displayName.indexOf('LTE 경제인구') !== -1) return "#6c4a85";
  else if (displayName.indexOf('2G 노년') !== -1) return "#8a7860";
  else if (displayName.indexOf('3G 노년') !== -1) return "#96d4df";
  else if (displayName.indexOf('LTE 노년') !== -1) return "#f7a33b";
  else if (displayName.indexOf('2G') !== -1) return "#41b2e6";
  else if (displayName.indexOf('3G') !== -1) return "#4452a8";
  else if (displayName.indexOf('LTE') !== -1) return "#fabc05";
  else if (displayName.indexOf('TBD') !== -1) return "#41b2e6";
  else if (displayName.indexOf('공업지역') !== -1) return "#4452a8";
  else if (displayName.indexOf('관리지역') !== -1) return "#fabc05";
  else if (displayName.indexOf('녹지지역') !== -1) return "#5587a2";
  else if (displayName.indexOf('농림지역') !== -1) return "#69cabc";
  else if (displayName.indexOf('상업지역') !== -1) return "#6c4a85";
  else if (displayName.indexOf('자연환경보전지역') !== -1) return "#8a7860";
  else if (displayName.indexOf('주거지역') !== -1) return "#96d4df";
  else if (displayName.indexOf('어린이') !== -1) return "#20ccc1";
  else if (displayName.indexOf('경제인구') !== -1) return "#5587a2";
  else if (displayName.indexOf('노년') !== -1) return "#f6a44c";
  else return "#cccccc";
}




window.labelFunc = function(index, value) {
  return '<font size="15">' + value + '</font>';
  return "";
};

window.labelFuncNum = function(index, value) {
  return '<font size="15">' + window.insertComma(value) + '</font>';
  return "";
};

window.totalFunc = function (index, data, value) {
  if ( index === 3 )
    return window.insertComma(value);
  return "";
};

//숫자에 천단위 콤마 찍어 반환하는 함수.
window.insertComma = function(n) {
  var reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n))
    n = n.replace(reg, '$1' + "," + '$2');
  return n;
};


window.dataTipFunc0_image = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>무선국 밀도</b> : " + window.insertComma(Number(values[1])) + "</font>";

};

window.dataTipFunc2_image = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>무선국 밀도</b> : " + window.insertComma(Number(values[1]).toFixed(2)) + "</font>";
};

window.dataTipFunc0 = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b> : " + window.insertComma(Number(values[1])) + "</font>";

};

window.dataTipFunc2 = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><font style='font-size:15px;'><b>" + values[0] + "</b> : " + window.insertComma(Number(values[1]).toFixed(2)) + "</font>";
};

window.dataTipFunc0_stacked = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b>"
    + "<br/>" + seriesName + " : " + window.insertComma(Number(values[1])) + "</font>";

};

window.dataTipFunc2_stacked = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b>"
    + "<br/>" + seriesName + " : " + window.insertComma(Number(values[1]).toFixed(2)) + "</font>";

};

window.dataTipFunc2_Pie = function(seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'>" + data.DATA_FIELD + " : <b>" + data.DATA_SUM_str
    + ", " + window.insertComma(Number(values[1]).toFixed(2)) + "%</b>" + "</font>";
};
